import React from 'react';

import { magellanV1 } from 'api/magellan';
import withSignageLayout from 'hoc/withSignageLayout';
import { useSignage } from 'hooks/useSignage';
import Loading from 'components/common/Loading';
import SignageHeader from 'components/common/SignageHeader';
import ToolForm from './ToolForm';

const initialValues = {
    name: '',
    uniqueId: '',
    brand: '',
    model: '',
    chassisNumber: '',
    comment: '',
};

const CreateWarehouse = ({ filterDataForServer }) => {
    const {editionMode, setEditionMode, createData, loading} = useSignage({ readApi: magellanV1, createApi: magellanV1, updateApi: magellanV1 }, 'devices', true, false);

    const onSubmit = (formValues) => {
        createData(filterDataForServer({...formValues}));
    };

    return (
        <>
            {loading 
                ? <Loading/>
                : <>
                    <SignageHeader editionMode={editionMode} setEditionMode={setEditionMode} editionEnabled={true}/>
                    <ToolForm 
                        editionMode={editionMode} 
                        onSubmit={onSubmit}
                        initialValues={initialValues}
                    />                
                </>
            }
        </>
    );
}

export default withSignageLayout()(CreateWarehouse);